// extracted by mini-css-extract-plugin
export default {"wrapper":"Amount_wrapper__AgxzY","decreaseIcon":"Amount_decreaseIcon__BTO3V","increaseIcon":"Amount_increaseIcon__-Hy+Y","value":"Amount_value__6FyhZ"};